<div class="promo-code" [formGroup]="stateService.form">
  
  <p class="section-title" translate="reg-form.referred"></p>

  <mat-form-field underlined appearance="outline">
    <mat-label>{{ 'reg-form.promo-code' | translate }}</mat-label>
    <input matInput placeholder="Promo code" formControlName="promoCode">
  </mat-form-field>

</div>
